const intialState = {
  eventType: ''
};

const submitValidationReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case 'GET_INPUT_VALIDATION_ON_SUBMIT':
      return {
        ...state,
        eventType: action.payload.eventType
      };
    case 'GET_INPUT_VALIDATION_ON_SUBMIT_CLEAR':
      return {
        ...state,
        eventType: ''
      };
    default:
      return state;
  }
};

export default submitValidationReducer;
